import { S126gS126m01Component } from './s126g-s126m01.component';

export { S126gModule } from './s126g.module';

export const S126gSubComponentsMap = {
	
};

export const S126gComponentsMap = {
	"s126g-s126m01": S126gS126m01Component
};

export const S126gComponents = [
	S126gS126m01Component
];

